import { Box, Button, Loader, Search } from "@wix/design-system";
import { debounce } from "lodash";
import React, { useContext, useEffect, useState } from "react";
import { PluginsEventsContext, RicosContext } from "./../../ricos-context";
import { MEDIA_POPOVERS_BUTTONS_NAMES_BI, uuid } from "./../../wix-rich-content-common";
import { unreachable } from "./../../editor-common";
import { FloatingLayout } from "./../../ui-components";
import { contentTypeMap } from "../constants";
import {
  INSERT_VERTICAL_EMBED_MODAL,
  INSERT_VERTICAL_EMBED_MODAL_SUBMIT,
  INSERT_VERTICAL_EMBED_SEARCH_INPUT
} from "../dataHooks";
import { VERTICAL_EMBED_TYPE } from "../types";
import { ItemsList } from "./ItemsList";
const VerticalEmbedInsertModal = ({
  verticalApi,
  componentData,
  onConfirm,
  onCancel
}) => {
  const { t, isMobile } = useContext(RicosContext);
  const pluginsEvents = useContext(PluginsEventsContext);
  const [state, setState] = useState({
    type: "LOADING",
    searchText: "",
    requestId: uuid()
  });
  useEffect(() => {
    onInputChange("");
  }, []);
  const onInputChange = debounce((inputString = "") => {
    const requestId = uuid();
    setState(() => ({
      type: "LOADING",
      searchText: inputString,
      requestId
    }));
    (async () => {
      try {
        const items = await verticalApi.search(inputString);
        setState((prev) => {
          if (prev.type === "LOADING" && prev.requestId !== requestId) {
            return prev;
          }
          return {
            type: "READY",
            items,
            selectedItem: null,
            searchText: inputString
          };
        });
      } catch (e) {
        console.error("Failed to load products", e);
        setState((prev) => {
          if (prev.type === "LOADING" && prev.requestId !== requestId) {
            return prev;
          }
          return {
            type: "READY",
            items: [],
            selectedItem: null,
            searchText: inputString
          };
        });
      }
    })();
  }, 300);
  const contentType = contentTypeMap[componentData.type];
  return /* @__PURE__ */ React.createElement(
    FloatingLayout,
    {
      onCloseButtonClick: onCancel,
      dataHook: INSERT_VERTICAL_EMBED_MODAL,
      header: {
        title: t(`Embed_Vertical_${contentType}_Title`),
        showDivider: false,
        children: /* @__PURE__ */ React.createElement(Box, { marginRight: "SP4", marginLeft: "SP4", marginBottom: "SP2" }, /* @__PURE__ */ React.createElement(
          Search,
          {
            size: "medium",
            value: state.searchText,
            onChange: (e) => onInputChange(e.target.value),
            onClear: () => onInputChange(""),
            placeholder: t(`Embed_Vertical_${contentType}_Placeholder`),
            dataHook: INSERT_VERTICAL_EMBED_SEARCH_INPUT
          }
        ))
      },
      content: {
        noPadding: true,
        children: (() => {
          switch (state.type) {
            case "LOADING":
              return /* @__PURE__ */ React.createElement(Box, { align: "center", verticalAlign: "middle", height: "252px" }, /* @__PURE__ */ React.createElement(Loader, null));
            case "READY":
              return /* @__PURE__ */ React.createElement(Box, { direction: "vertical", height: "252px" }, /* @__PURE__ */ React.createElement(
                ItemsList,
                {
                  selectedItem: state.selectedItem,
                  items: state.items,
                  onClick: (item) => {
                    state.selectedItem && item.id === state.selectedItem?.id ? onConfirm(toAppEmbedData(state.selectedItem, componentData)) : setState((prev) => ({ ...prev, selectedItem: item }));
                  },
                  contentType
                }
              ));
            default:
              unreachable(state);
              return null;
          }
        })()
      },
      footer: {
        showDivider: false,
        children: /* @__PURE__ */ React.createElement(
          Button,
          {
            onClick: () => {
              pluginsEvents.publishPluginPopoverClick?.({
                pluginId: VERTICAL_EMBED_TYPE,
                buttonName: MEDIA_POPOVERS_BUTTONS_NAMES_BI.embed
              });
              if (state.type !== "READY" || !state.selectedItem) {
                return;
              }
              onConfirm(toAppEmbedData(state.selectedItem, componentData));
            },
            disabled: state.type !== "READY" || !state.selectedItem,
            fullWidth: true,
            stretchVertically: isMobile,
            dataHook: INSERT_VERTICAL_EMBED_MODAL_SUBMIT
          },
          t("Embed_Add_Button_Label")
        )
      }
    }
  );
};
const toAppEmbedData = (item, componentData) => {
  const verticalData = componentData.type === "BOOKING" ? { bookingData: { durations: item.durations + "" } } : componentData.type === "EVENT" ? { eventData: { scheduling: item.scheduling, location: item.location } } : {};
  return {
    ...componentData,
    name: item.name,
    itemId: item.id,
    url: item.pageUrl,
    image: { src: { url: item.imageSrc }, height: item.imageHeight, width: item.imageWidth },
    ...verticalData
  };
};
export {
  VerticalEmbedInsertModal
};
//# sourceMappingURL=VerticalEmbedInsertModal.js.map
